"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _interfaces = require("../interfaces");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TD = function TD(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? _interfaces.EUiContainers.TR : _ref$tag,
    styles = _ref.styles,
    testId = _ref.testId;
  switch (tag) {
    case _interfaces.EUiContainers.DIV:
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": testId,
        className: className,
        style: styles
      }, children);
    case _interfaces.EUiContainers.LI:
      return /*#__PURE__*/_react["default"].createElement("li", {
        "data-testid": testId,
        className: className,
        style: styles
      }, children);
    default:
      return /*#__PURE__*/_react["default"].createElement("td", {
        "data-testid": testId,
        className: className,
        style: styles
      }, children);
  }
};
var _default = /*#__PURE__*/_react["default"].memo(TD);
exports["default"] = _default;